import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { setNewForm } from 'apps/auth/actions/formAction';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import Form from 'apps/auth/components/form-multi/Form';
import InputText from 'apps/auth/components/form-multi/InputText';
import { getField } from 'apps/auth/components/form-multi/utils';
import Loading from 'apps/auth/components/utils/Loading';
import { EMAIL_POPUP_FORM_NAME } from 'apps/auth/constants/formName';
import { REGEXP_EMAIL } from 'apps/auth/constants/RegExps';
import { GET_RECEIPT_URL } from 'apps/auth/constants/UrlConstants';
import { useCheck, useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const EmailPopup = ({ isGlobalAccount = false, payId, popupRef = null, setNewForm }) => {
    const { email } = useExtra();
    const { paymentId } = useCheck() || {};
    const { emailHeader, emailPlaceholder, emailButton } = usePageMessages();
    const form = useForm(EMAIL_POPUP_FORM_NAME);

    useEffect(() => {
        const emailField = getField('email', email ? email : '', REGEXP_EMAIL, true, false, emailPlaceholder, 'email');
        const paymentIdField = getField('paymentId', '' + (isGlobalAccount ? payId : paymentId));
        setNewForm(EMAIL_POPUP_FORM_NAME, {
            [emailField.name]: emailField,
            [paymentIdField.name]: paymentIdField,
        });
    }, []);

    const onSubmitHandler = () => {
        popupRef.current?.close();
    };

    if (!form) {
        return <Loading />;
    }

    return (
        <ComplexPopup
            primaryButtonType="submit"
            primaryButtonForm="get_receipt"
            primaryButtonTabIndex="1002"
            primaryButtonText={emailButton}
            textCenter
            popupRef={popupRef}
        >
            <ComplexPopupRow>
                <p>{emailHeader}</p>
            </ComplexPopupRow>
            <Form id="get_receipt" action={GET_RECEIPT_URL} formName={EMAIL_POPUP_FORM_NAME} fields={form.fields} onSubmitHandler={onSubmitHandler}>
                <InputText field={form.fields.email} formName={EMAIL_POPUP_FORM_NAME} focus={true} isNewInput />
            </Form>
        </ComplexPopup>
    );
};

EmailPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(null, { setNewForm })(EmailPopup);
